export const getAccountsFormData = (formData) => {
  return formData.accounts
    ? Object.entries(formData.accounts)
        .filter((account) => account[1])
        .map((account) => account[0])
    : null;
};
